<template>
  <div class="offcanvas-body">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="d-flex align-items-center py-4 cursor-pointer"
      :class="{ 'border-bottom': index !== items.length - 1 }"
      @click="item.action"
    >
      <i
        :class="[
          item.icon,
          { 'text-primary50': !item.enabled, 'text-primary': item.enabled },
        ]"
        class="fa-lg"
        style="width: 35px"
      />
      <div>
        <div class="d-flex align-items-center">
          <p
            class="mb-0 text-paragraph"
            :class="{ 'text-primary50': !item.enabled }"
          >
            {{ item?.value }}
          </p>
          <span v-if="!item.enabled" class="ms-2 badge bg-info rounded-4"
            >Paiapp +</span
          >
        </div>
      </div>
      <i class="fa-solid fa-chevron-right ms-auto"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMainStore } from "@/store";
import { EOffcanvasViews, navigateCanvas } from "../OffcanvasViewsConfig";

const { session } = useMainStore();

const items = [
  {
    value: "Nome e telefone",
    action: () => navigateCanvas(EOffcanvasViews.account_update, null, false),
    icon: "fa-solid fa-user",
    enabled: true,
  },
  {
    value: "Imagem de perfil",
    action: () => navigateCanvas(EOffcanvasViews.profile_image, null, false),
    icon: "fa-solid fa-image",
    enabled: true,
  },
  {
    value: "Depoimentos",
    action: () => {
      if (session?.is_plus) {
        navigateCanvas(EOffcanvasViews.ratings, null, false);
        return;
      }
      navigateCanvas(EOffcanvasViews.subscription, null, false);
    },
    icon: "fa-solid fa-star",
    enabled: session?.is_plus,
  },
  {
    value: "Idiomas",
    action: () => navigateCanvas(EOffcanvasViews.languages, null, false),
    icon: "fa-solid fa-earth",
    enabled: true,
  },
  {
    value: "Vídeo de introdução",
    action: () => {
      if (session?.is_plus) {
        navigateCanvas(EOffcanvasViews.intro_video, null, false);
        return;
      }
      navigateCanvas(EOffcanvasViews.subscription, null, false);
    },
    icon: "fa-brands fa-youtube",
    enabled: session?.is_plus,
  },
  {
    value: "Valor da sessão",
    action: () =>
      navigateCanvas(EOffcanvasViews.appointment_price, null, false),
    icon: "fa-solid fa-dollar",
    enabled: true,
  },
  {
    value: "Informações de formação",
    action: () => navigateCanvas(EOffcanvasViews.about, null, false),
    icon: "fa-solid fa-image-portrait",
    enabled: true,
  },
  {
    value: "Fotos do CRP",
    action: () => navigateCanvas(EOffcanvasViews.crp, null, false),
    icon: "fa-solid fa-id-card",
    enabled: true,
  },
  {
    value: "Especialidades",
    action: () => navigateCanvas(EOffcanvasViews.specialties, null, false),
    icon: "fa-solid fa-stethoscope",
    enabled: true,
  },
  {
    value: "Abordagens",
    action: () => navigateCanvas(EOffcanvasViews.approaches, null, false),
    icon: "fa-solid fa-tasks",
    enabled: true,
  },
  {
    value: "Disponibilidade de horários",
    action: () => navigateCanvas(EOffcanvasViews.schedule_info, null, false),
    icon: "fa-solid fa-clock",
    enabled: true,
  },
  {
    value: "Gênero",
    action: () => navigateCanvas(EOffcanvasViews.gender, null, false),
    icon: "fa-solid fa-venus-mars",
    enabled: true,
  },
];
</script>
